<template>
  <v-flex
    id="maintenanceExpenses"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheetOne.hint_material') }}
    </p>
    <h2 class="display-3 display-3_dark">
      {{ getMaintenanceExpensesQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getMaintenanceExpensesQuestions.hasOwnProperty('costs')"
        class="mt-4"
      >
        <p class="header required mb-0">
          {{ getMaintenanceExpensesQuestions.costs.label }}
        </p>
        <monthlyExpensesForm
          class="font-weight-regular"
          :read-only="readOnly"
          @value="monthly = $event"
        />
      </li>
      <li
        v-if="getMaintenanceExpensesQuestions.hasOwnProperty('is_spending_nursery')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getMaintenanceExpensesQuestions.is_spending_nursery.required }"
        >
          {{ getMaintenanceExpensesQuestions.is_spending_nursery.label }}
        </p>
        <ConfirmButtons
          v-model="isSpendingNursery"
          v-validate="{ required: getMaintenanceExpensesQuestions.is_spending_nursery.required }"
          string
          :error-messages="errors.collect('isSpendingNursery')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'isSpendingNursery'"
          :disabled="readOnly"
        />
        <div
          v-if="
            isSpendingNursery === 'yes' &&
              getMaintenanceExpensesQuestions.hasOwnProperty('nursery_cost')
          "
        >
          <v-layout
            class="mt-4"
            align-center
          >
            <v-flex
              xs12
              md6
              lg4
              class="font-weight-regular"
            >
              <v-text-field
                v-model="nurseryCost"
                v-validate="{
                  ...requiredMoney(getMaintenanceExpensesQuestions.nursery_cost.required)
                }"
                :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
                :label="getMaintenanceExpensesQuestions.nursery_cost.label"
                :error-messages="errors.collect('garten_price')"
                :data-vv-name="'garten_price'"
                :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.garten_price')"
                :required="getMaintenanceExpensesQuestions.nursery_cost.required"
                :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
                inputmode="decimal"
                :disabled="readOnly"
              />
            </v-flex>
          </v-layout>
        </div>
      </li>
      <li
        v-if="
          isSpendingNursery === 'yes' && getMaintenanceExpensesQuestions.hasOwnProperty('take_job')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getMaintenanceExpensesQuestions.take_job.required }"
        >
          {{ getMaintenanceExpensesQuestions.take_job.label }}
        </p>
        <ConfirmButtons
          v-model="takeJob"
          v-validate="{ required: getMaintenanceExpensesQuestions.take_job.required }"
          string
          :error-messages="errors.collect('takeJob')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'takeJob'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getMaintenanceExpensesQuestions.hasOwnProperty('transport_cost')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getMaintenanceExpensesQuestions.transport_cost.required }"
        >
          {{ getMaintenanceExpensesQuestions.transport_cost.label }}
        </p>
        <ConfirmButtons
          v-model="transportCost"
          v-validate="{ required: getMaintenanceExpensesQuestions.transport_cost.required }"
          string
          :error-messages="errors.collect('transportCost')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'transportCost'"
          :disabled="readOnly"
        />
        <div
          v-if="
            transportCost === 'yes' &&
              getMaintenanceExpensesQuestions.transport_cost.hasOwnProperty('transport_expenses')
          "
        >
          <v-layout
            class="mt-4"
            align-center
          >
            <v-flex
              xs12
              md6
              lg4
              class="font-weight-regular"
            >
              <v-text-field
                v-model="transportExpenses"
                v-validate="{
                  ...requiredMoney(
                    getMaintenanceExpensesQuestions.transport_cost.transport_expenses.required
                  )
                }"
                :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
                :label="getMaintenanceExpensesQuestions.transport_cost.transport_expenses.label"
                :error-messages="errors.collect('transport_expenses')"
                :data-vv-name="'transport_expenses'"
                :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.garten_price')"
                :required="
                  getMaintenanceExpensesQuestions.transport_cost.transport_expenses.required
                "
                :suffix="$t('sheet.sheetOne.meeting.maintenance_expenses.per-month')"
                inputmode="decimal"
                :disabled="readOnly"
              />
            </v-flex>
          </v-layout>
        </div>
      </li>
      <li
        v-if="
          transportCost === 'yes' &&
            getMaintenanceExpensesQuestions.transport_cost &&
            getMaintenanceExpensesQuestions.transport_cost.hasOwnProperty(
              'transport_expenses_justification'
            )
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{
            required:
              getMaintenanceExpensesQuestions.transport_cost.transport_expenses_justification
                .required
          }"
        >
          {{
            getMaintenanceExpensesQuestions.transport_cost.transport_expenses_justification.label
          }}
        </p>
        <ConfirmButtons
          v-model="transportExpensesJustification"
          v-validate="{
            required:
              getMaintenanceExpensesQuestions.transport_cost.transport_expenses_justification
                .required
          }"
          string
          :error-messages="errors.collect('transportExpensesJustification')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'transportExpensesJustification'"
          :disabled="readOnly"
        />
      </li>
    </ul>
    <moneySummary
      :value="summaryPLN"
      :title="getMaintenanceExpensesQuestions.total_amount.label"
    />
  </v-flex>
</template>

<script>
import MonthlyExpensesForm from '@/components/widgets/sheet/questions/maintenanceExpenses/monthlyExpensesForm';
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import MoneySummary from '@/components/widgets/sheet/moneySummary';
import validationRules from '@/constants/validationRules';

import filters from '@/constants/filters';

import formatDecimalVariables from '@/mixins/formatDecimalVariables';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'sheet/getMaintenanceExpensesField',
    mutationType: 'sheet/updateMaintenanceExpensesField'
});

export default {
    name: 'MaintenanceExpenses',
    components: { MoneySummary, ConfirmButtons, MonthlyExpensesForm },
    filters: { ...filters },
    mixins: [formatDecimalVariables, sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            monthly: 0
        };
    },
    watch: {
        isSpendingNursery: {
            immediate: true,
            handler (val) {
                if (val === 'no') {
                    this.nurseryCost = '';
                    this.takeJob = null;
                }
            }
        },
        summaryPLN: {
            immediate: true,
            handler (summaryPLN) {
                this.totalAmount = summaryPLN;
            }
        },
        transportCost: {
            handler (val) {
                if (val !== 'yes') {
                    this.transportExpenses = '';
                    this.transportExpensesJustification = null;
                }
            }
        }
    },
    computed: {
        ...mapFields([
            'isSpendingNursery',
            'nurseryCost',
            'takeJob',
            'totalAmount',
            'transportExpensesJustification',
            'transportCost',
            'transportExpenses'
        ]),
        ...mapGetters('sheet', ['getMaintenanceExpensesQuestions']),
        summaryPLN () {
            let summary = 0;
            if (this.takeJob === 'yes') {
                summary += parseFloat(
                    this.$options.filters.emptyToZero(this.formatDecimalVariable(this.nurseryCost))
                );
            }
            if (this.transportCost === 'yes') {
                summary += parseFloat(
                    this.$options.filters.emptyToZero(this.formatDecimalVariable(this.transportExpenses))
                );
            }
            return parseFloat(this.monthly + summary).toFixed(2);
        }
    }
};
</script>

<style scoped></style>
